// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1F1_wVXLkUwP5l5U72Xfy3{width:100%}._1F1_wVXLkUwP5l5U72Xfy3 .navigation{display:none}._1F1_wVXLkUwP5l5U72Xfy3 ._header{display:none !important}\n", "",{"version":3,"sources":["webpack://src/client/pages/policy/pages/zip-policy/style.module.scss"],"names":[],"mappings":"AAAA,yBACI,UAAW,CADf,qCAKY,YAAa,CALzB,kCASY,uBAAwB","sourcesContent":[".Container{\n    width: 100%;\n\n    :global{\n        .navigation{\n            display: none;\n        }\n    \n        ._header{\n            display: none !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": "_1F1_wVXLkUwP5l5U72Xfy3"
};
module.exports = ___CSS_LOADER_EXPORT___;
